export default "__VITE_ASSET__abb02aab__"